var exports = {
  "kL": "xe564cbfb--096990--container",
  "jq": "xe564cbfb--096990--contact",
  "nf": "xe564cbfb--096990--link",
  "J6": "xe564cbfb--096990--left-column",
  "BI": "xe564cbfb--096990--favorite",
};

module.exports = exports;
